var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEducation(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 57.085,
    height: 56.139,
    viewBox: "0 0 57.085 56.139",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_2331",
    "data-name": "Ret\\xE2ngulo 2331",
    width: 57.085,
    height: 56.139,
    fill: "#4a35d9",
    stroke: "#4a35d9",
    strokeWidth: 1
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_19679",
    "data-name": "Grupo 19679",
    transform: "translate(-1396.218 -2207.156)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_4596",
    "data-name": "Grupo 4596",
    transform: "translate(1396.218 2207.156)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_4091",
    "data-name": "Grupo 4091",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_910",
    "data-name": "Caminho 910",
    d: "M6.893,11.638H32.352V8.805H6.893Zm0,6.9H32.352V15.708H6.893Zm0,6.9H32.352V22.606H6.893ZM57.085,40.666V9.678L56.63,9.26,46.6,0H0V40.666H32.875A9.377,9.377,0,0,0,35.242,45.4L29.217,56.134H41.466V48.369c.214.01.423.031.643.031a9.188,9.188,0,0,0,1.615-.152v7.885H55.967L49.555,44.711a9.362,9.362,0,0,0,1.787-4.045ZM47.5,4.687l4.541,4.191H47.5ZM38.633,53.3H34.056l3.433-6.124a9.2,9.2,0,0,0,1.144.549Zm3.475-7.734a6.556,6.556,0,1,1,6.553-6.558,6.565,6.565,0,0,1-6.553,6.558M51.128,53.3H46.55l.005-6.02a9.576,9.576,0,0,0,.883-.549ZM42.108,29.624A9.393,9.393,0,0,0,32.8,37.834H2.832v-35H44.664v8.878h9.589V37.834H51.41a9.388,9.388,0,0,0-9.3-8.209",
    transform: "translate(0 0.002)",
    fill: "#4a35d9",
    stroke: "#4a35d9",
    strokeWidth: 1
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEducation);
export default __webpack_public_path__ + "static/media/education.7ba7b1e10256bc4baac9d4921023b976.svg";
export { ForwardRef as ReactComponent };